import { SolicitudAusenciaService } from "services";
import {
    filtroColaboradorAtom,
    filtroFechaInicioAtom,
    filtroFechaFinAtom,
    filtroTipoAusenciaAtom,
    filtroEstadoAprobacionAtom,
    filtroPerfilAtom,
    filtroSeccionAtom,
} from "../consultaSolicitudesStore";
import { useAtom } from "jotai";
import { saveAs } from "file-saver";
import { notification } from "antd";
import { useState } from "react";

const useGenerarReporteExcelPCA = () => {
    const [filtroColaborador] = useAtom(filtroColaboradorAtom);
    const [filtroFechaInicio] = useAtom(filtroFechaInicioAtom);
    const [filtroFechaFin] = useAtom(filtroFechaFinAtom);
    const [filtroTipoAusencia] = useAtom(filtroTipoAusenciaAtom);
    const [filtroEstadoAprobacion] = useAtom(filtroEstadoAprobacionAtom);
    const [filtroPerfil] = useAtom(filtroPerfilAtom);
    const [filtroSeccion] = useAtom(filtroSeccionAtom);
    const [loadingPCA, setLoadingPCA] = useState(false);

    const generarReportePCA = async (formato = "xlsx") => {
        try {
            setLoadingPCA(true);
            const respuesta = await SolicitudAusenciaService.descargarReporteExcelPCA({
                colaborador: filtroColaborador,
                mesInicio: filtroFechaInicio,
                mesFin: filtroFechaFin,
                estadoAprobacion: filtroEstadoAprobacion,
                tipoAusencia: filtroTipoAusencia,
                perfil: filtroPerfil,
                seccion: filtroSeccion,
            }, formato);
            setLoadingPCA(false);
            const filename = respuesta.headers.filename || `Reporte PCA.${formato}`;
            saveAs(respuesta.data, filename);
        } catch (error) {
            setLoadingPCA(false);
            notification.error({
                message: "Error al exportar PCA",
                description: error?.response?.data?.mensaje || "No se pudo generar el reporte PCA.",
            });
        }
    };

    return { generarReportePCA, loadingPCA };
};

export default useGenerarReporteExcelPCA;
